import { render } from "./picture.vue?vue&type=template&id=1a51b34a&scoped=true&ts=true"
import script from "./picture.vue?vue&type=script&lang=ts"
export * from "./picture.vue?vue&type=script&lang=ts"

import "./picture.vue?vue&type=style&index=0&id=1a51b34a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a51b34a"]])

export default __exports__